const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Archived Manager Directive to display a list or table with archived content to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Content the resource defined to get and set Content data
 */
app.directive('archivedManager', ['Application', 'Authorization', 'Viewables', 'AdminContent', '$translate', function(Application, Authorization, Viewables, AdminContent, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        tabName: '=',
        refresh: '=',
        type: '@?'
      },
      template: require('../../templates/directives/archived-manager.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.type = $scope.type;
          self.translations = {};
          self.features = Application.features.flags();

          self.settings = {
            per_page: 5,
            contentTypes: ['files', 'videos', 'articles', 'tracks', 'scorm', 'imported_content'],
            initialized: false,
            searching: false
          };

          if (self.features.presentations) {
            self.settings.contentTypes.push('presentations');
          }

          if (self.features.imported_content) {
            self.settings.contentTypes.push('imported_content');
          }

          if ($scope.type) {
            if ($scope.type === 'polls') {
              self.settings.contentTypes = ['poll'];
            }
            if ($scope.type === 'workshops') {
              self.settings.contentTypes = ['workshops'];
            }
            if ($scope.type === 'assessments') {
              self.settings.contentTypes = ['assessments'];
            }
          }

          self.settings.stringTypes = self.settings.contentTypes.join(',');

          self.isCollaborator = function() {
            return Authorization.isCollaborator();
          };

          self.getStandardQuery = function() {
            return {
              types: self.settings.contentTypes.join(','),
              page: 1,
              per_page: self.settings.per_page,
              archived: true,
              sort: 'updatedAt,-1',
              'user-populate': 'first_name,last_name,full_name,email'
            };
          }

          self.content = {
            loading: false,
            list: [],
            query: {},
            get: function() {
              self.content.loading = true;

              return AdminContent.find(this.query).$promise.then(function(results) {
                self.content.loading = false;
                self.content.list = results.data;
                self.content.list.sort(function(a, b) {
                  if (!b.updatedAt || !a.updatedAt) {
                    return b.updatedAt - a.updatedAt;
                  }
                  return new Date(b.updatedAt) - new Date(a.updatedAt);
                });
                self.content.previousAvailable = false;
                self.content.nextAvailable = !!results.next_exists;

                if (self.content.query.page > 1) {
                  self.content.previousAvailable = true;
                }

              });
            },
            next: function() {
              // return if there are no next available types
              if (!self.content.nextAvailable) {
                return;
              }

              self.content.query.page++;
              self.content.previousAvailable = true;
              self.content.get();
            },
            previous: function() {
              if (self.content.query.page < 1) {
                return;
              }
              self.content.query.page--;
              self.content.get();
            },
            nextAvailable: true,
            previousAvailable: false
          };

          self.content.query = self.getStandardQuery();

          self.selections = {
            loading: false,
            selected: [],
            directory: {},
            select: function(item) {
              var id = item._id;
              var index = this.selected.indexOf(id);
              if (index === -1) {
                this.selected.push(id);
                this.directory[id] = item;
                return;
              }
              this.selected.splice(index, 1);
              delete this.directory[id];
            },
            removeSelections: function() {
              for (var i = this.selected.length - 1; i >= 0; i--) {
                this.select(this.directory[this.selected[i]]);
              }
            },
            unarchive: function() {
              var selection = this.selected.map(function(item) {
                if (!self.selections.directory[item] || !self.selections.directory[item].type) {
                  return;
                }
                return {
                  id: item,
                  type: self.selections.directory[item].type
                };
              });
              this.loading = true;
              Viewables.unarchive({content: selection}).$promise
                  .then(function(results) {
                    var removals = {};
                    if (results.unarchived && results.unarchived.length) {
                      for (var i = 0; i < results.unarchived.length; i++) {
                        removals[results.unarchived[i]] = true;
                        self.selections.select({_id: results.unarchived[i]});
                      }
                    }
                    for (var j = self.content.list.length - 1; j > -1; j--) {
                      if (self.content.list[j]._id && removals[self.content.list[j]._id]) {
                        self.content.list.splice(j, 1);
                      }
                    }
                    $scope.refresh = 'all';
                    self.selections.loading = false;

                    self.content.query.page = 1;
                    self.content.get();

                    if (!results.errors || !results.errors.length) {
                      Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['archivedManager.all_content_unarchived']});
                      return;
                    }
                    Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['archivedManager.not_all_unarchived']});
                  }).catch(function(error) {
                Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['archivedManager.not_all_unarchived']});
                console.log('error: ', error);
              });
            }
          };

          self.searchItems = {
            placeholder: ("Search Archived " + (self.type ? self.type.charAt(0).toUpperCase() + self.type.substr(1) : 'Content')),
            onQuery: function(opts) {
              self.content.query = self.getStandardQuery();
              self.settings.searching = false;

              if (opts && typeof opts === 'object' && Object.keys(opts).length) {
                self.settings.searching = true;
              }
              if (!self.settings.searching) {
                self.content.get();
                return;
              }

              for (var key in opts) {
                self.content.query[key] = opts[key];
              }
              self.content.get();
            }
          };

          self.initialize = function() {
            self.content.get().then(function(results) {
              self.settings.initialized = true;
            });
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (!self.settings.initialized || !newVal || newVal === oldVal || newVal !== 'archived' && newVal !== 'all') {
              return;
            }
            self.content.get();
            $scope.refresh = null;
          });

          self.initialize();

          $translate([
            'archivedManager.all_content_unarchived',
            'archivedManager.not_all_unarchived',
            'archivedManager.not_all_unarchived'
          ]).then(function(translations) {
            self.translations = translations;
          });

        }],
      controllerAs: 'archived'
    };
  }]);
